/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";

// Saved queries only change their own list; no report data depends on them.
const savedReportQueryKeys = mergeQueryKeys(getBaseQueryKey(Query_Keys.saved_report_queries));

export const savedReportQueryMutationKeyGroups = {
  create: savedReportQueryKeys,
  update: savedReportQueryKeys,
  remove: savedReportQueryKeys,
};
